import { createFileRoute } from "@tanstack/react-router";
import { MarketingHero } from "@/components/marketing-hero";
import { MarketingPageShell } from "@/components/marketing-page-shell";
import { buildPageHead } from "@/lib/seo-meta";

const path = "/cursor-social-media";

export const Route = createFileRoute(path)({
	component: CursorSocialMedia,
	head: ({ matches }) =>
		buildPageHead({
			matches,
			internalPath: path,
			title: "Boost your Social Media using Cursor",
			description:
				"Schedule and publish social media posts directly from Cursor. AgentReacher's MCP server turns Cursor into a publishing tool for your launches.",
		}),
});

function CursorSocialMedia() {
	return (
		<MarketingPageShell>
			<MarketingHero
				agent="cursor"
				title="Boost your Social Media using Cursor"
				description="AgentReacher's MCP server runs in Cursor. Draft a launch tweet next to the diff that shipped it. Schedule a thread without switching context."
				primaryCta={{ label: "Connect Cursor", to: "/signup" }}
				secondaryCta={{ label: "Setup docs", to: "/docs/mcp" }}
			/>
		</MarketingPageShell>
	);
}
